<template>
    <div class="popup type2 active">
        <div class="popup__inner type2">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>개인정보 수집·이용 동의</h2>
                    <button type="button" class="popup__close" @click="hidePopup"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="text-box-scroll">
                        <div>
                            <p class="point-desc mb title03">
                                개인정보 수집·이용 동의 (필수)
                            </p>
                            1. 개인정보 의 수집·이용목적 : 두통수첩 <br>
                            2. 수집하는 개인정보의 항목 <br>
                            
                            <p class="point-desc font-main">필수 정보 : 날짜, 시간, 통증부위, 통증강도, 통증유형, 추가특이사항</p>
                            3. 개인정보의 보유·이용기간 : <span class="point-desc c-red">회원 탈퇴 시 까지</span> <br>
                            4. 귀하는 위와 같은 개인정보 수집·이용에 동의하지 않으실 수 있습니다. 동의하지 않을 시 나의 건강관리 서비스가 제한될 수 있습니다.
                        </div>
                    </div>
                    <div class="checkbox-wrap">
                        <label  >
                            <input type="checkbox" name="test01" id="test01" v-model="agree">
                            <span class="checkbox-btn"></span>
                            <p><span class="c-red">*</span> 동의합니다</p>
                        </label>
                    </div>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="hidePopup">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="confirm">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                agree: false,
            }
        },
        methods: {
            confirm(){
                if(this.agree){
                    this.$emit('confirm');
                }else{
                    alert('개인정보 수집·이용에 대한 동의를 해주세요.')
                }

            },
            hidePopup() {
                this.agree = false

                this.$emit('hide-popup');
            },
        },
    }
</script>